module.exports = "<my-area-edit-form my-area=\"$$area.data.myArea\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-area-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/area/templates/edit.html
// module id = 1485
// module chunks = 0